module.exports = __webpack_public_path__ + "img/pressing_the_key.4fbcc28a.jpg";